import KeyValueLabel from './KeyValueLabel';

export default KeyValueLabel;
